import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';

import { GAMES } from '../config';

var appStateKey = '.app__initial-state';

var StateModel = Backbone.Model.extend({
  defaults: function () {
    return {
      requestId: '',
      env: '',
      game: null,
      gameName: '',
      ssn: 0,
      gameInfoSrl: 0,
      msn: 0,
      usn: 0,
      gsn: 0,
      nru: null,
      howPcbang: false,
      guest: false,
      loginUrl: '',
      loggedIn: false,
      membership: null,
      membershipRemaining: null,
      subscription: false,
      vipGrade: 0, // VIP 1~4까지. 0, -1은 일반
      channelling: null,
      mfaService: '',
      mfaActivated: null,
      mfaDeprecated: null,
      maintenance: null,
      maintenanceMessage: '',
      imagePath: ''
    };
  },

  initialize: function () {
    this.fetch();
  },

  parse: function (value) {
    var imagePath = '';
    if (/qa|tq/.test(value.env)) {
      imagePath = '//file.pmang.com/nps/poker/v2/qa';
    } else {
      imagePath = '//file.pmang.com/nps/poker/v2/live';
    }
    return _.extend(value, {
      imagePath: imagePath
    });
  },

  setGame: function (game) {
    var switchingGame = GAMES[game];

    this.save({
      game: game,
      gameName: switchingGame.name,
      ssn: switchingGame.ssn,
      gameInfoSrl: switchingGame.gameInfoSrl,
      msn: switchingGame.msn
    });
  },

  checkMFAActivated: function () {
    return this.get('mfaActivated');
  },

  checkMFADeprecated: function () {
    return this.get('mfaDeprecated') && this.checkMFAActivated();
  },

  authenticateMFA: function (isPassed) {
    this.save({ mfaActivated: !isPassed });
  },

  sync: function (method, model) {
    var initialState;
    var nextState;
    var $state = $(appStateKey);

    if (method === 'create' || method === 'update') {
      nextState = _.clone(model.attributes);
      $state.data(nextState);
    } else if (method === 'read') {
      initialState = $state.eq(0).data();
      model.set(this.parse(initialState));
    }
  }
});

export var state = new StateModel();
